import React from 'react';
import BaseCard from '../../../components/misc/BaseCard.jsx';
import IconTicketItem from '../../../components/images/IconTicketItem.jsx';
import dayjs from 'dayjs';

const getStatusColorClass = (status, type = 'bg') => {
    const colorClasses = {
        open: {
            bg: 'bg-theme1-brightRed2',
            text: 'text-theme1-brightRed2'
        },
        'in-progress': {
            bg: 'bg-theme1-warning',
            text: 'text-theme1-warning'
        },
        resolved: {
            bg: 'bg-theme1-success',
            text: 'text-theme1-success'
        }
    };

    return colorClasses[status]?.[type] || (type === 'bg' ? 'bg-gray-400' : 'text-gray-700');
};

const TicketsItem = ({ ticket, adminTicket }) => {
    const formattedStatus = ticket.status
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    return (
        <BaseCard className='py-4 px-5 m-0 bg-theme1-white'>
            <div className='flex gap-2'>
                <div className='w-[22px] h-[22px] bg-theme1-primary2 rounded-full flex justify-center items-center flex-shrink-0'>
                    <IconTicketItem className='stroke-white w-[10px] h-[9px]' />
                </div>

                <div className='flex-1'>
                    <div className='flex justify-between gap-2 mb-1'>
                        {adminTicket ? (
                            <div className='text-base text-theme1-primary2 leading-none mt-[3px] font-bold capitalize'>
                                {ticket.threads[0].user.name}
                            </div>
                        ) : (
                            <div className='text-base text-theme1-primary2 leading-none mt-[3px]'>
                                Ticket type: <span className='capitalize font-bold'>{ticket.type}</span>
                            </div>
                        )}

                        <div
                            className={`text-[10px] text-white self-start rounded-md py-1 px-2 font-extrabold flex-shrink-0 ml-auto ${getStatusColorClass(ticket.status, 'bg')}`}
                        >
                            {formattedStatus}
                        </div>
                    </div>
                    {adminTicket && (
                        <div className='text-xs text-theme1-primary  font-semibold'>
                            Ticket type: <span className='capitalize'>{ticket.type}</span>
                        </div>
                    )}
                    <div className='text-xs text-theme1-text2 mt-1'>
                        Added on <span className='font-semibold'>{dayjs(ticket.created_at).format('DD.MM.YYYY')}</span>
                    </div>
                    <div className='text-sm text-theme1-primary2 mt-1 whitespace-pre-wrap'>
                        {ticket.threads?.[0]?.text.length > 150
                            ? `${ticket.threads[0].text.slice(0, 150)}...`
                            : ticket.threads[0].text}
                    </div>
                </div>
            </div>
        </BaseCard>
    );
};

export default TicketsItem;
